(() => {
  'use strict';
  if (window.NaturaSwatchRequestForms) { window.NaturaSwatchRequestForms.init(document); return; }
  function init(root) {
    root.querySelectorAll('form[data-swatch-request-form]').forEach(form => {
      if (form.dataset.swatchInitialized === 'true') return;
      const body = form.querySelector('[data-swatch-request-body]');
      const submit = form.querySelector('[data-swatch-submit]');
      if (!body || !submit || Number(form.dataset.swatchConfigured) < 1) return;
      const fields = Array.from(form.querySelectorAll('[data-swatch-field]'));
      const buildBody = () => {
        const requestType = form.querySelector('[data-swatch-request-type]');
        const lines = [requestType.value];
        fields.forEach(field => {
          const value = field.value.trim() || form.dataset.emptyLabel;
          lines.push(field.dataset.swatchLabel + ': ' + value);
        });
        body.value = lines.join('\n');
      };
      form.addEventListener('input', buildBody);
      form.addEventListener('change', buildBody);
      // Build the body before Shopify's normal submit/captcha handlers. Never fake success or override the destination.
      form.addEventListener('submit', buildBody, true);
      buildBody();
      form.dataset.swatchInitialized = 'true';
      submit.disabled = false;
    });
  }
  window.NaturaSwatchRequestForms = { init };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(document));
  else init(document);
  document.addEventListener('shopify:section:load', event => init(event.target));
})();
